import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import productData from "./json/productData.json"; // JSON dosyası
import { FaSearch } from "react-icons/fa";

const ProductCard = ({ product, index }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <motion.div
      ref={ref}
      className="col-span-1 mb-4 relative group overflow-hidden"
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay: index * 0.2 }}
    >
      <div className="bg-gray-100 shadow-md rounded-lg h-full relative group">
        <div className="flex flex-col items-center p-4">
          {/* Ürün Görseli */}
          <img
            src={product.productImage}
            alt={product.alt}
            className="w-32 h-48 object-contain mb-4"
          />
          {/* Ürün İsmi */}
          <p className="text-center text-lg font-medium text-gray-700">
            {product.name}
          </p>
        </div>
        {/* Hemen Sat Butonu */}
        <button
          className="w-full bg-black text-white text-center py-3 rounded-b-lg z-10 relative transition duration-500 hover:bg-gradient-to-r hover:from-orange-500 hover:via-red-500 hover:to-pink-500"
          onClick={() => (window.location.href = product.link)}
        >
          <span className="text-sm uppercase tracking-wide">Hemen Sat</span>
        </button>
      </div>
    </motion.div>
  );
};

const ProductsPage = ({ category }) => {
  const [searchTerm, setSearchTerm] = useState(""); // Arama çubuğu için state
  const products = productData[category]; // JSON içindeki ilgili kategori ürünlerini getir

  if (!products) {
    return (
      <div className="container mx-auto p-4 max-w-7xl text-center">
        <h1 className="text-2xl font-bold text-gray-800">Ürünler Bulunamadı</h1>
        <p className="text-gray-600">
          "{category}" kategorisine ait ürün bulunamadı.
        </p>
      </div>
    );
  }

  // Arama çubuğu filtreleme
  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container mx-auto p-4 max-w-7xl">
      {/* Arama Çubuğu */}
      <div className="flex items-center justify-center py-4 bg-white">
        <div className="w-full max-w-2xl flex items-center border-b border-gray-300">
          <input
            type="text"
            placeholder="İstediğiniz modeli yazarak filtreleyebilirsiniz."
            className="flex-grow text-gray-600 placeholder-gray-400 focus:outline-none px-2 py-2 text-lg"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)} // Arama terimini güncelle
          />
          <button className="text-gray-500 hover:text-black px-4">
            <FaSearch size={20} />
          </button>
        </div>
      </div>

      {/* Başlık */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">
          {category} Modelleri
        </h1>
        <p className="text-gray-600">
          İstediğiniz modeli seçin ve hemen satmaya başlayın!
        </p>
      </div>

      {/* Ürün Kartları */}
      {filteredProducts.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredProducts.map((product, index) => (
            <ProductCard key={product.name} product={product} index={index} />
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-600">
          "{searchTerm}" ile eşleşen ürün bulunamadı.
        </div>
      )}
    </div>
  );
};

export default ProductsPage;
